import { format } from "date-fns";
import { Component, EventEmitter, Input, OnInit, Output, TemplateRef, ViewChild } from "@angular/core";
import { UntypedFormBuilder, UntypedFormGroup } from "@angular/forms";
import { PlatformType } from "@root/config";
import * as moment from "moment";
import { NzMessageService } from "ng-zorro-antd/message";
import _, { omit } from "lodash";
import { OrderV2Service } from "@root/router/order-v2/order-v2.service";
import { TranslateService } from "@root/shared/service/translate.service";
import { NzModalService } from "ng-zorro-antd/modal";
import { Router } from "@angular/router";
import { NzDrawerService } from "ng-zorro-antd/drawer";
import { RateDetailComponent } from "../../rate-detail/rate-detail.component";
import { WritePermissionGurd } from "@root/util/decorator";
import { DateService } from "@root/shared/service/date.service";
import { Observable, forkJoin } from "rxjs";
import { CacheService } from "@delon/cache";
import { tap } from "rxjs";
import { AppService } from "@root/app.service";
import { splitCountryCodeAndMobile } from "@root/util/util";
import { NzSelectComponent } from "ng-zorro-antd/select";
// import { formatNumber } from "@angular/common";

@Component({
  selector: "host-widget-basic-block",
  templateUrl: "./basic-block.component.html",
  styleUrls: ["./basic-block.component.scss"],
})
export class WidgetBasicBlockComponent implements OnInit {
  _orderDetail;
  @Input()
  get orderDetail() {
    return this._orderDetail;
  }
  set orderDetail(value) {
    this._orderDetail = value;

    if (value) {
      const [countryCode, mobile] = splitCountryCodeAndMobile(value.client?.phone);
      this.countryCode = countryCode;
      this.form.patchValue({
        channel: value?.handmade_chanel,
        name: value?.client?.name,
        mobile: mobile,
        date: value?.is_hour_reservation ? value.check_in : [value.check_in, value.check_out],
        number_of_guests: value.number_of_guests || 1,
        guests: {
          adults: value.number_of_adults || 1,
          children: value.number_of_children || 0,
          infants: value.number_of_infants || 0,
          pets: value.number_of_pets || 0,
        },
      });

      this.initGuestDetailInfo();

      if (this.isInternational) {
        this.fetchCountryCodes();
      }
    }
  }
  @Input() isEditing = false;
  @Output() onEdit = new EventEmitter();
  @Output() onCancelEdit = new EventEmitter();
  @Output() onCompleteEdit = new EventEmitter();
  @Output() onLockOrder = new EventEmitter();
  @Output() onRevokeCheckStatus = new EventEmitter();
  @Output() onClickGuestDetail = new EventEmitter();
  @ViewChild("virtualNumberForm") virtualNumberForm: TemplateRef<any>;
  optionsOfManualChannel = [];
  generalRemarkUnfold = false;

  listOfCountryCode = [];
  countryCode;

  get isInternational() {
    return this.app.app.international;
  }

  get isDirectBooking() {
    return this.orderDetail?.thirdparty_type === 5;
  }

  get isPendingVerify() {
    return this.orderDetail?.is_pending_verify === 1;
  }

  get isHourReservation() {
    return this.orderDetail?.is_hour_reservation;
  }

  get displayRemark() {
    return this.orderDetail?.remark;
  }

  /**
   * 4.2.0 修改了这里的逻辑。展示邮箱只考虑房客是否有邮箱
   * mantis: http://mantis.xiaogetech.com/mantis/view.php?id=6220
   */
  get displayEmail() {
    return this.orderDetail?.client?.email;
  }

  get displayVirtualNumber() {
    return [PlatformType.TuJia, PlatformType.MeiTuanMinSu].includes(this.orderDetail?.thirdparty_type);
  }

  get totalNights() {
    return moment(this.orderDetail?.check_out).diff(this.orderDetail?.check_in, "days") || 0;
  }

  get resvCheckinText() {
    const range = `${this.dateSrv.format(this.orderDetail?.check_in, ["YMD"])} ~ ${this.dateSrv.format(
      this.orderDetail?.check_out,
      ["YMD"],
    )}`;
    const nights = `${this.totalNights} ${this.t.t(`word.night${this.totalNights > 1 ? "s" : ""}`)}`;
    return `${range}  ${nights}`;
  }

  //#region 小时单
  get hourStartTime() {
    return `${this.orderDetail?.check_in} ${this.orderDetail?.check_in_time}`;
  }
  get hourEndTime() {
    return `${this.orderDetail?.check_out} ${this.orderDetail?.check_out_time}`;
  }
  get totalHours() {
    const start = moment(this.hourStartTime);
    const end = moment(this.hourEndTime);
    return end.diff(start, "hours");
  }

  get hourResvCheckinText() {
    const date = this.dateSrv.format(this.orderDetail?.check_in, ["MD"]);
    const time = `${this.dateSrv.format(this.hourStartTime, [null, "hm"])}~${this.dateSrv.format(this.hourEndTime, [
      null,
      "hm",
    ])}`;
    const length = this.t.t(`order.hour_order_total_hour${this.totalHours > 1 ? "s" : ""}`, { hour: this.totalHours });
    return `${date}  ${time}  ${length}`;
  }

  //#endregion

  get angularDateFormat() {
    return this.dateSrv.getAngularFormat(["YMD"]);
  }

  form: UntypedFormGroup = this.fb.group({
    date: null,
    channel: null,
    name: null,
    mobile: null,
    // number_of_guests: null,
    guests: {
      adults: 1,
      children: 0,
      infants: 0,
      pets: 0,
    },
  });

  virtualNumber = this.cache.getNone("hostex-client-virtual-number");

  get guestDetailInfo() {
    const result = [];

    [
      { key: "number_of_adults", s: "adult", p: "adults" },
      { key: "number_of_children", s: "child", p: "children" },
      { key: "number_of_infants", s: "infant", p: "infants" },
      { key: "number_of_pets", s: "pet", p: "pets" },
    ].forEach((item) => {
      const value = this.orderDetail?.[item.key];
      if (value) {
        result.push(`${value} ${value > 1 ? item.p : item.s}`);
      }
    });

    // if (this.orderDetail?.number_of_adults) {
    //   result.push(this.orderDetail?.number_of_adults + " adults");
    // }
    // if (this.orderDetail?.number_of_infants) {
    //   result.push(this.orderDetail?.number_of_infants + " infant");
    // }
    // if (this.orderDetail?.number_of_children) {
    //   result.push(this.orderDetail.number_of_children + " children");
    // }
    // if (this.orderDetail?.number_of_pets) {
    //   result.push(this.orderDetail.number_of_pets + " pets");
    // }
    if (result.length) {
      return `(${result.join(" / ")})`;
    }
    return "";
  }

  constructor(
    private app: AppService,
    private fb: UntypedFormBuilder,
    private cache: CacheService,
    private msg: NzMessageService,
    private modal: NzModalService,
    private drawer: NzDrawerService,
    private orderSrv: OrderV2Service,
    private dateSrv: DateService,
    private t: TranslateService,
    private router: Router,
  ) {}

  ngOnInit() {
    this.initChannelOptions();
  }

  private fetchCountryCodes() {
    this.cache.get("/api/schedule/staff/mobile_codes").subscribe((rst: any) => {
      this.listOfCountryCode = rst?.data?.codes?.map((c) => ({
        label: c,
        value: c,
      }));
      if (!this.countryCode) {
        this.countryCode = this.listOfCountryCode?.[0]?.value;
      }
    });
  }

  private initChannelOptions() {
    this.orderSrv.getSettings().subscribe((rst) => {
      this.optionsOfManualChannel = rst?.data?.reservation_channel
        ?.filter((c) => !c.delete_time && ![5, 20, 21].includes(c.code))
        .map((c) => ({ label: c.channel_name, value: c.code }));
    });
  }

  private requestVirtualNumber() {
    const params = {
      code: this.orderDetail.code,
      calling_mobile: this.virtualNumber,
    };
    this.orderSrv.requestGetVirtualNumber(params).subscribe((rst: any) => {
      if (rst.error_code === 0) {
        this.displayRequestVirtualNumberSuccessModal(rst?.data?.mobile);
      } else {
        this.displayRequestVirtualNumberFailModal(rst.error_msg);
      }
      this.onCompleteEdit.emit();
    });
  }

  private displayVirtualNumberForm() {
    return new Observable((observer) => {
      const modal = this.modal.create({
        nzTitle: "输入本机号码",
        nzContent: this.virtualNumberForm,
        nzOkText: "申请",
        nzOnOk: () => observer.next(null),
      });
      modal.afterClose.subscribe(() => observer.complete());
    });
  }

  private displayRequestVirtualNumberSuccessModal(number) {
    this.modal.success({
      nzTitle: "申请成功",
      nzContent: `虚拟号码为：${number}`,
      nzOkText: "复制",
      nzOnOk: () => {
        navigator.clipboard.writeText(number).then(() => {
          this.msg.success(this.t.t("success.copy"));
        });
      },
    });
  }

  private displayRequestVirtualNumberFailModal(reason) {
    this.modal.error({
      nzTitle: "申请失败",
      nzContent: reason,
      nzOkText: null,
    });
  }

  private initGuestDetailInfo() {
    const result = [];
    if (this.orderDetail?.number_of_adults) {
      result.push(this.orderDetail?.number_of_adults + " adults");
    }
    if (this.orderDetail?.number_of_infant) {
      result.push(this.orderDetail?.number_of_infant + " infant");
    }
    if (this.orderDetail?.number_of_children) {
      result.push(this.orderDetail.number_of_children + " children");
    }
    if (this.orderDetail?.number_of_pets) {
      result.push(this.orderDetail.number_of_pets + " pets");
    }
    if (result.length) {
      return `(${result.join(" / ")})`;
    }
    return "";
  }

  getHandMadeChannel(channel) {
    const item = _.find(this.optionsOfManualChannel, { value: channel });
    return item?.label;
  }

  onModifyBasicInfo() {
    const form = this.form.value;
    const date = form.date;

    const isHourReservation = this.orderDetail.is_hour_reservation;

    const check_in = moment(isHourReservation ? date : date[0]).format("YYYY-MM-DD");
    const check_out = moment(isHourReservation ? date : date[1]).format("YYYY-MM-DD");

    if (!isHourReservation && check_in === check_out) {
      return this.msg.warning(this.t.t("errorText.order.in_out_date"));
    }

    const mobile = form.mobile ? (this.isInternational ? `${this.countryCode} ${form.mobile}` : form.mobile) : null;
    const guests = this.form.value.guests;

    const params = {
      ...omit(form, ["date", "guests"]),
      mobile,
      check_in,
      check_out,
      reservation_code: this.orderDetail.code,

      number_of_adults: guests.adults,
      number_of_children: guests.children,
      number_of_infants: guests.infants,
      number_of_pets: guests.pets,
    };

    this.orderSrv.modifyBasicInfo(params).subscribe((rst: any) => {
      if (rst.error_code === 0) {
        this.onCompleteEdit.emit();
        this.msg.success(this.t.t("success.save"));

        if (this.orderDetail.sync_lock === 0) {
          this.onLockOrder.emit();
        }
      }
    });
    // this.orderSrv.modifyBasicInfo(params).subscribe((rst) => {});
  }

  //#region Guest number

  // /** @deprecated */
  // private requestUpdateGuestNumber() {
  //   const guests = this.form.value.guests;

  //   const params = {
  //     reservation_code: this.orderDetail.code,
  //     number_of_adults: guests.adults,
  //     number_of_children: guests.children,
  //     number_of_infants: guests.infants,
  //     number_of_pets: guests.pets,
  //   };

  //   return this.orderSrv.requestUpdateGuestNumber(params);
  // }

  //#endregion

  onRequestVirtualNumber() {
    this.displayVirtualNumberForm()
      .pipe(
        tap(() => {
          this.cache.set("hostex-client-virtual-number", this.virtualNumber);
        }),
      )
      .subscribe(() => {
        this.requestVirtualNumber();
      });
  }

  /** trick  */
  onSearchBlur(tpl: NzSelectComponent) {
    this.countryCode = tpl.activatedValue;
  }

  toLogPage(logType, code) {
    this.router.navigate(["/app/system"], {
      queryParams: { tab: 1, logType, code },
    });
  }

  @WritePermissionGurd("reservation_list")
  toInboxPage() {
    this.modal.closeAll();
    this.router.navigate(["/app/inbox"], {
      queryParams: {
        thread_id: this.orderDetail.thread_id,
      },
    });
  }

  toRateDetail() {
    const ref = this.drawer?.create({
      nzTitle: this.t.t("rate_detail.header.title"),
      nzContent: RateDetailComponent,
      nzMask: true,
      nzMaskClosable: true,
      nzMaskStyle: { opacity: 0 },
      nzWidth: 500,
      nzContentParams: {
        code: this.orderDetail.code,
      },
    });
    ref.afterClose.subscribe(() => {
      this.onCompleteEdit.emit();
    });
  }
}
